<template>
  <div v-bind:class="{ 'form-group': true, 'has-error': this.m_error !== null }">
    <label>{{ field.label }}</label>
    <input
      type="text"
      class="form-control"
      v-on:keypress="isNumber($event)"
      placeholder="Preencha o campo"
      v-model="m_fieldAnswer.value"
      :disabled="disabledAttribute"
    />
  </div>
</template>

<script>
  export default {
    props: ['field', 'fieldAnswer', 'isDisabled'],
    name: 'IntegerField',
    data () {
      return {
        m_fieldAnswer: {
          fieldUuid: this.field.uuid,
          value: this.fieldAnswer.value
        },
        m_error: null,
        m_rowIndex: this.fieldAnswer.rowIndex
      }
    },
    computed: {
      disabledAttribute () {
        return this.field.disabled === true || this.isDisabled === true
      }
    },
    watch: {
      'm_fieldAnswer.value' () {
        this.$emit('fieldUpdated', this.m_rowIndex, { fieldUuid: this.m_fieldAnswer.fieldUuid, value: parseInt(this.m_fieldAnswer.value) })
      }
    },
    methods: {
      isNumber (evt) {
        evt = !(evt) ? window.event : evt
        var charCode = (evt.which) ? evt.which : evt.keyCode
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          evt.preventDefault()
          return false
        }
        return true
      },
      isValid () {
        if (this.field.required && !this.m_fieldAnswer.value && this.m_fieldAnswer.value !== 0) {
          this.m_error = true
          return false
        }
        if (
          this.m_fieldAnswer.value &&
          (!(/^\d+$/.test(this.m_fieldAnswer.value)) || this.m_fieldAnswer.value.toString().length > 19)
        ) {
          this.m_error = true
          return false
        }

        this.m_error = null
        return true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// IntegerField.vue?08387f43